import round1image from './img/1.png';
import round2image from './img/2.png';
import round3image from './img/3.png';
import round4image from './img/4.png';
import round5image from './img/5.png';
import round6image from './img/6.png';
import round7image from './img/7.png';
import round8image from './img/8.png';
import round9image from './img/9.png';
import round10image from './img/10.png';
import upImage from './img/up.png';
import downImage from './img/down.png';
export default {
	1: round1image,
	2: round2image,
	3: round3image,
	4: round4image,
	5: round5image,
	6: round6image,
	7: round7image,
	8: round8image,
	9: round9image,
	10: round10image,
	warmups: upImage,
	cooldowns: downImage,
};



// WEBPACK FOOTER //
// ./src/workoutPreview/_roundImagesEnum.js